<template>
  <div>
    <div v-if="loading" :style="{height: height + 'px'}" class="position-relative">
      <svg-loader/>
    </div>

    <slot v-else/>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean
    },
    height: {
      type: Number,
      default: 300
    }
  }
};
</script>
